/**
 * Brand-accurate SVG icons for share targets. Each component returns a
 * standalone <svg> with the brand's official colour so it reads
 * instantly without relying on a 3rd-party icon library that may render
 * a generic glyph.
 *
 *   <BrandIcon brand="whatsapp" size={22} />
 *   <BrandIcon brand="instagram" size={22} />
 *   <BrandIcon brand="x"        size={22} />
 */

export function WhatsAppIcon({ size = 22, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
    >
      <path
        fill="#25D366"
        d="M16 0a16 16 0 0 0-13.7 24.2L0 32l8-2.2A16 16 0 1 0 16 0Z"
      />
      <path
        fill="#FFFFFF"
        d="M23.4 19.5c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7 0a8.7 8.7 0 0 1-4.3-3.8c-.3-.6.3-.5.9-1.7.1-.2 0-.4 0-.5l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5 0-.8.4-.3.4-1.1 1.1-1.1 2.7s1.1 3.1 1.2 3.4c.2.3 2.2 3.4 5.4 4.8 2 .8 2.8.9 3.8.7.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4Z"
      />
    </svg>
  );
}

export function InstagramIcon({ size = 22, className = "" }) {
  const gradId = "ig-grad";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id={gradId} cx="0.3" cy="1" r="1.2">
          <stop offset="0%" stopColor="#FED373" />
          <stop offset="20%" stopColor="#F15245" />
          <stop offset="55%" stopColor="#D92E7F" />
          <stop offset="85%" stopColor="#9B36B7" />
          <stop offset="100%" stopColor="#515ECF" />
        </radialGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="8" fill={`url(#${gradId})`} />
      <rect
        x="6.5"
        y="6.5"
        width="19"
        height="19"
        rx="6"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2"
      />
      <circle cx="16" cy="16" r="4.6" fill="none" stroke="#FFFFFF" strokeWidth="2" />
      <circle cx="22.4" cy="9.6" r="1.4" fill="#FFFFFF" />
    </svg>
  );
}

export function XIcon({ size = 22, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="8" fill="#0A0A0A" />
      <path
        fill="#FFFFFF"
        d="M22.5 7h2.7l-5.9 6.7L26 25h-5.4l-4.2-5.5L11.5 25H8.8l6.3-7.2L8 7h5.5l3.8 5 4.2-5Zm-1 16h1.5L11.5 8.5H10L21.5 23Z"
      />
    </svg>
  );
}

const REGISTRY = {
  whatsapp: WhatsAppIcon,
  instagram: InstagramIcon,
  x: XIcon,
  twitter: XIcon,
};

export function BrandIcon({ brand, size = 22, className = "" }) {
  const Cmp = REGISTRY[brand];
  if (!Cmp) return null;
  return <Cmp size={size} className={className} />;
}
